<template>
    <div class="schedule-course">
        <div class="schedule-course__head">
            <a class="schedule-course__title"
                 href="#schedule-search"
                 data-show-toggler="course"
                 v-html="$options.filters.highlight(scheduleCourse.name, filterSearch)"
                 @click="autoInput(scheduleCourse.name)"
            >
                {{scheduleCourse.name}}
            </a>
            <div class="schedule-course__date" v-if="scheduleCourse.dateStart && scheduleCourse.dateEnd">
                <span>с {{scheduleCourse.dateStart}} до {{scheduleCourse.dateEnd}}</span>
            </div>
            <div class="schedule-course__manager"
                 v-if="scheduleCourse.manager">
                <span>Организатор курса:</span> {{scheduleCourse.manager}}
            </div>
            <div class="schedule-course__phone"
                 v-if="scheduleCourse.phone">
                <span>Телефон:</span> {{scheduleCourse.phone}}
            </div>
        </div>
        <schedule-list-course-classes
            v-for="(item,inx) in scheduleCourse.classes"
            :key="inx"
            :course-classes="item"
        />
    </div>
</template>

<script>
  import ScheduleListCourseClasses from "./ScheduleListCourseClasses";
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "ScheduleListCourse",
    components: {ScheduleListCourseClasses},
    props: {
      scheduleCourse: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState([
        'filterSearch'
      ]),
    },
    methods: {
      ...mapActions([
        'setFilterSearchURL',
      ]),
      autoInput(val) {
        this.setFilterSearchURL(val.trim())
      }
    }
  }
</script>
